import React from 'react';
import PropTypes from 'prop-types';
import AsyncReactSelect from 'react-select/async';
import { createFilter } from 'react-select';

import './style.scss';
import { ControlWithTestId, OptionWithTestId, styles } from '.';

function AsyncMultiselect(props) {
  const { label, id, inputId, placeholder, value, className, checkboxFirst, menuPositionFixed = true, onChange, searchByLabelOnly,
    loadOptions,
    defaultOptions,
    cacheOptions,
    ...otherProps } = props;

  const getLabel = option => (
    <React.Fragment key={`option_${option.value}_${value.includes(option.value)}`}>
      {option.label}
      <input
        type="checkbox"
        defaultChecked={value.some(v => v.value === option.value)}
        disabled={option.isDisabled}
        data-testid={`option[${option.value}][${value.includes(option.value)}]`}
      />
    </React.Fragment>
  );

  const defaultFilter = {
    ignoreCase: true,
    ignoreAccents: true,
    matchFrom: 'any',
    stringify: option => `${option.data.label} ${option.data.value}`,
    trim: true,
  };


  return (
    <>
      <label htmlFor={id} className="visuallyhidden">
        {label}
      </label>
      <AsyncReactSelect
        id={id}
        className={`${className || ''} ${checkboxFirst ? 'checkboxFirst' : ''} react-select-container multi-select`}
        classNamePrefix="react-select"
        value={value}
        onChange={onChange}
        unstyled
        styles={styles}
        placeholder={placeholder}
        menuPosition={menuPositionFixed ? 'fixed' : 'absolute'}
        menuPortalTarget={menuPositionFixed ? document.body : undefined}
        isMulti
        controlShouldRenderValue={false}
        isClearable={false}
        hideSelectedOptions={false}
        getOptionLabel={props.getLabel || getLabel}
        filterOption={searchByLabelOnly ? createFilter({ stringify: option => option.data.label }) : createFilter(defaultFilter)}
        loadOptions={loadOptions}
        cacheOptions={cacheOptions}
        defaultOptions={defaultOptions || undefined}
        backspaceRemovesValue={false}
        classNames={{
          menuPortal: () => `multi-select ${checkboxFirst ? 'checkboxFirst' : ''} ${className || ''}`,
        }}
        inputId={inputId || `${id}-input`}
        components={{ Option: OptionWithTestId, Control: ControlWithTestId }}
        {...otherProps}
      />
    </>
  );
}

AsyncMultiselect.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.array,
  data: PropTypes.array.isRequired,
  closeMenuOnSelect: PropTypes.bool,
  menuPositionFixed: PropTypes.bool,
  label: PropTypes.string,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  checkboxFirst: PropTypes.bool,
  searchByLabelOnly: PropTypes.bool,
  loadOptions: PropTypes.func.isRequired,
  cacheOptions: PropTypes.bool,
  getLabel: PropTypes.func,
  defaultOptions: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),
};

export default AsyncMultiselect;
